import React from "react";

import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "reactstrap";

export default class DialogBase extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            title: this.props.title ? this.props.title : '!!! タイトル未設定',
            size: this.props.size ? this.props.size : 'lg',
            default_footer_enable: this.props.default_footer ? false : true,
            positive: this.props.positive ? this.props.positive : false,
            newtral: this.props.newtral ? this.props.newtral : false,
            negative: this.props.negative ? this.props.negative : true,
            class: this.props.class ? this.props.class : "",
            positive_label: this.props.positive_label ? this.props.positive_label : 'はい',
            newtral_label: this.props.newtral_label ? this.props.newtral_label : 'キャンセル',
            negative_label: this.props.negative_label ? this.props.negative_label : 'いいえ',
            disablePositive:false,
            newtral_color: this.props.newtral_color ? this.props.newtral_color : null,
            newtral_right_alignment: this.props.newtral_right_alignment ? this.props.newtral_right_alignment : false,
        };
        this.toggleModal = this.toggleModal.bind(this);
        this.bodyContent = this.bodyContent.bind(this);
        this.handleClickPositive = this.handleClickPositive.bind(this);
        this.handleClickNewtral = this.handleClickNewtral.bind(this);
        this.handleClickNegative = this.handleClickNegative.bind(this);
    }

    show() {
        this.setState({ modal: true }, () => {
            this.initialize();
        });
    }

    initialize() {
        return;
    }

    toggleModal() {
        this.setState({
            modal: !this.state.modal
        });
    }

    bodyContent() {
        return (
            <>
            </>
        );
    }

    footerContent() {
        return (
            <>
            </>
        );
    }

    handleClickPositive() {
        this.props.handleClickPositive && this.props.handleClickPositive();
        this.toggleModal();
    }

    handleClickNewtral() {
        this.props.handleClickNewtral && this.props.handleClickNewtral();
        this.toggleModal();
    }

    handleClickNegative() {
        this.props.handleClickNegative && this.props.handleClickNegative();
        this.setState({
            modal: false
        });
    }

    render() {
        let body_content = this.bodyContent();
        let footer_content = this.footerContent();
        return (
            <Modal size={this.state.size} isOpen={this.state.modal} className={this.state.class}>
                <div className="modal-header">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleClickNegative}>
                        <i className="tim-icons icon-simple-remove"></i>
                    </button>
                    <span>
                        <h5 className="modal-title float-left">{this.state.title}</h5>
                    </span>
                </div>
                {this.props.isLostOrder ? <>{body_content}</> : <ModalBody>{body_content}</ModalBody>}
                <ModalFooter className={this.state.default_footer_enable ? (this.state.newtral_right_alignment ? "modal-footer-right-alignment" : "") : "off"}>
                    {footer_content}
                    {(this.state.default_footer_enable && this.state.negative) && <Button color="secondary" onClick={this.handleClickNegative}>{this.state.negative_label}</Button>}
                    {(this.state.default_footer_enable && this.state.newtral) && <Button color={this.state.newtral_color ? this.state.newtral_color : "secondary"} onClick={this.handleClickNewtral}>{this.state.newtral_label}</Button>}
                    {(this.state.default_footer_enable && this.state.positive) && <Button disabled={this.state.disablePositive} color="info" onClick={this.handleClickPositive}>{this.state.positive_label}</Button>}
                </ModalFooter>
            </Modal>
        );
    }
}
